import type { FileUploadOptions } from '../types';

export interface ValidationResult {
  valid: boolean;
  error?: string;
}

/**
 * Validates a file against the provided options
 */
export function validateFile(
  file: File,
  options?: FileUploadOptions
): ValidationResult {
  const { maxSize, allowedExtensions } = options || {};

  // Check file size
  if (maxSize && file.size > maxSize) {
    return {
      valid: false,
      error: `File size exceeds the maximum allowed size of ${formatFileSize(maxSize)}`,
    };
  }

  // Check file extension
  if (allowedExtensions && allowedExtensions.length > 0) {
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
      return {
        valid: false,
        error: `File type not allowed. Allowed types: ${allowedExtensions.join(', ')}`,
      };
    }
  }

  return { valid: true };
}

/**
 * Formats file size in bytes to human-readable format
 */
function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Math.round((bytes / Math.pow(k, i)) * 100) / 100} ${sizes[i]}`;
}
